import { CheckMarkIcon } from "../../../../components/Icons/CheckMarkIcon";
import { CrossMarkIcon } from "../../../../components/Icons/CrossMarkIcon";
import React from "react";

export const RowWithSingleField = ({ title, value, className, valueClassName = "" }) => (
    <div className={`row ${className}`}>
        <h5 className="row-title">{title}</h5>
        <div className={`row-value ${valueClassName}`}>{value}</div>
    </div>
);

export const YesNoToggle = ({ isYes }) => (
    <div className={`icon ${isYes ? "yes" : "no"}`}>
        {isYes && <CheckMarkIcon />}
        {!isYes && <CrossMarkIcon />}
    </div>
);

export const YesNoRow = ({ title, isYes }) => (
    <div className="row yes-no">
        <h5 className="row-title">{title}</h5>
        <YesNoToggle isYes={isYes} />
    </div>
);
